module.exports = __webpack_public_path__ + "static/media/chat-light.ec250673.svg";